<template>
  <div>
    <h1
      v-if="this.$route.name !== 'Reservoirs'"
      class="font-weight-bold mt-2 mb-4"
      style="font-size: 20px; line-height: 23px"
    >
      Estimativa de chuva
    </h1>
    <v-row align="center" v-if="this.$route.name !== 'Reservoirs'">
      <v-col cols="12" md="6">
        <v-icon
          class="mr-2"
          size="16"
          color="white"
          :style="`height: 24px; width: 24px; border-radius: 50%;background-color: ${basinIconColor};`"
          >{{ basinIconName }}</v-icon
        >
        <span v-if="location" class="pt-1" style="font-size: 16px">{{
          location.text
        }}</span>
      </v-col>
    </v-row>
    <v-card color="mt-3 pa-2 primary darken-1">
      <v-row class="pa-6" align="center">
        <v-icon class="mr-1" size="16">restore</v-icon>
        <h1
          style="
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
          "
        >
          {{ this.lastUpdateSiprecDaily() }}
        </h1>
      </v-row>
      <v-card-title class="mb-0">
        <chart-header
          :authorize="authorize"
          :enableExportChart="enableExportChart"
          @fullscreenChart="fullscreenChart"
          @printChart="printChart"
          @exportChart="exportChart($event)"
          @exportCSV="exportCSV"
          @exportXLS="exportXLS"
        >
          <template v-slot:title> Dados de precipitação </template>
        </chart-header>
      </v-card-title>

      <v-card-text>
        <h3 class="subtitle-1 white--text">Selecione o tipo do dado</h3>
        <div class="d-flex align-center">
          <v-tabs
            class="hidden-sm-and-down secondary--text text--lighten-1"
            v-model="tab"
            active-class="secondary lighten-1 primary--text text--darken-1"
            background-color="primary darken-1"
            slider-color="secondary lighten-1"
          >
            <v-tab
              class="tab-item-title"
              v-for="(item, index) in items"
              :key="index"
              :id="item.id"
            >
              {{ item.title }}
            </v-tab>
          </v-tabs>

          <v-menu bottom left>
            <template v-slot:activator="{on, attrs}">
              <v-btn
                class="hidden-md-and-up tab-item-title tranparent"
                outlined
                v-bind="attrs"
                v-on="on"
              >
                {{ items[tab].title }}
                <v-icon> mdi-menu-down </v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                v-for="(item, index) in items"
                :key="index"
                @click="changeTabItem(index)"
              >
                {{ item.title }}
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn
            v-if="this.$route.name !== 'Reservoirs'"
            link
            @click="goToPage()"
            class="mx-auto button-text secondary--text text--lighten-1 subtitle-2 font-weight-medium"
            height="40"
            text
          >
            <v-icon left size="24">language</v-icon>
            <span>Consultar dados históricos</span>
            <v-icon right size="24">mdi-open-in-new</v-icon>
          </v-btn>
        </div>

        <v-tabs-items v-model="tab" class="primary darken-1" touchless>
          <v-tab-item class="px-0">
            <v-card flat color="primary darken-1">
              <v-card-text class="px-0 text-center">
                <rain-historic-chart
                  v-if="historicSiprecDailyEstimated"
                  ref="rainHistoricChart"
                  :location="location"
                  :forecasts="historicSiprecDailyEstimated"
                  :min-days-forecast="29"
                  @chartRenderComplete="chartRenderComplete($event)"
                >
                </rain-historic-chart>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat color="primary darken-1">
              <v-card-text class="px-0 text-center">
                <rain-estimation-table
                  class="mt-8 mb-6"
                  :show-in-map="true"
                  :locations="[location]"
                  :forecasts="forecastsTable"
                  :siprecDailyEstimated="siprecDailyEstimatedToTable"
                  :min-days-forecast="6"
                  :max-days-forecast="6"
                >
                </rain-estimation-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import momentTimeZone from 'moment-timezone';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/export-data';
import RainEstimationTable from './RainEstimationTable.vue';
import RainHistoricChart from './RainHistoricChart.vue';
import ChartHeader from '../ChartHeader.vue';
import {rainHistoricChartAuthorization} from '../../../helpers/chart_export_authorization';
Exporting(Highcharts);
export default {
  name: 'RainEstimation',
  components: {
    RainEstimationTable,
    RainHistoricChart,
    ChartHeader,
  },
  props: {
    location: {
      required: true,
    },
    forecasts: {
      require: true,
    },
    siprecDailyEstimated: {
      require: true,
    },
    basinIcon: {
      type: Object,
      default: () => ({name: 'icon-infohidro-bacia', color: '#69D7A3'}),
    },
    from: {
      type: String,
    },
  },
  data: () => ({
    tab: 0,
    chartRendered: undefined,
    enableExportChart: false,
    exportChartAuthorized: undefined,
    items: [
      {
        title: 'Histórico da estimativa',
        id: 'tab-rain-historic',
      },
      {
        title: 'Estimativa e previsão',
        id: 'tab-rain-estimation',
      },
    ],
    authorize: [],
  }),
  watch: {
    watchLocationAndForecastsValues() {
      if (this.location && this.forecasts && this.siprecDailyEstimated) {
        this.loadCharts();
      }
    },
    tab(value) {
      if (value === 1) {
        this.enableExportChart = true;
        this.loadCharts();
      } else {
        this.enableExportChart = false;
      }

      this.$gtag.event('tabs_' + this.from + '-RainEstimation', {
        event_category: 'RainEstimation',
        event_label: 'tab_index',
        value: value,
      });
    },
  },

  computed: {
    watchLocationAndForecastsValues() {
      return [this.location, this.forecasts, this.siprecDailyEstimated];
    },
    historicSiprecDailyEstimated() {
      return this.siprecDailyEstimated;
    },
    forecastsTable() {
      return this.forecasts.filter(
        (forecast) => forecast.sourceid === 22,
      );
    },
    siprecDailyEstimatedToTable() {
      // last 10 elements are enough for the table
      return this.siprecDailyEstimated.slice((this.siprecDailyEstimated.length - 10), this.siprecDailyEstimated.length);
    },
    basinIconName() {
      return this.basinIcon.name ? this.basinIcon.name : 'icon-infohidro-bacia';
    },
    basinIconColor() {
      return this.basinIcon.color ? this.basinIcon.color : '#69D7A3';
    },
  },
  methods: {
    loadCharts() {
      setTimeout(() => {
        if (this.$refs.rainHistoricChart && this.siprecDailyEstimated.length) {
          this.$refs.rainHistoricChart.chartPreprocessing();
          this.authorize = rainHistoricChartAuthorization;
        }
      }, 50);
    },
    chartRenderComplete(chart) {
      this.chartRendered = chart;
    },
    exportChart(typeFile) {
      this.chartRendered.exportChart({type: typeFile});
    },
    exportCSV() {
      this.chartRendered.downloadCSV();
    },
    exportXLS() {
      this.chartRendered.downloadXLS();
    },
    fullscreenChart() {
      const fullscreenControl = new Highcharts.Fullscreen(this.chartRendered);
      fullscreenControl.open();
    },
    printChart() {
      this.chartRendered.print();
    },

    lastUpdateSiprecDaily() {
      let lastUpdate = this.forecasts.find(
        (forecast) => forecast.sourceid === 26,
      );
      let modelStartedDate = this.forecasts.find(
        (forecast) => forecast.sourceid === 22,
      );

      if (lastUpdate && modelStartedDate) {
        lastUpdate = momentTimeZone(lastUpdate.updated).tz(lastUpdate.timezone);
        modelStartedDate = momentTimeZone(modelStartedDate.runtime).tz(
          modelStartedDate.timezone,
        );
        return `Atualizado em ${lastUpdate.format('DD/MM/YYYY [às] HH:mm')}.`;
      }

      return '';
    },
    changeTabItem(tabIndex) {
      this.tab = tabIndex;
    },
    exportChartAuthorization(authorization) {
      this.exportChartAuthorized = authorization;
    },
    goToPage() {
      let routePath =
        '/RainEstimationHistoricalData/' +
        this.$route.name +
        '/' +
        this.location.locationid;
      this.$router.push(routePath);
    },
  },
};
</script>

<style scoped>
.tab-item-title {
  color: var(--v-secondary-lighten1) !important;
  border: 1px solid var(--v-secondary-lighten1);
  text-transform: none;
}
#tab-rain-estimation {
  border-radius: 4px 0px 0px 4px;
}
#tab-rain-historic {
  border-radius: 0px 4px 4px 0px;
}
</style>
